import { API_BASE_URL, request } from '@/api/http'

export function getMediaHubHome(params = {}) {
  const query = new URLSearchParams()
  if (params.area) query.set('area', params.area)
  if (params.limit) query.set('limit', params.limit)
  const suffix = query.toString() ? `?${query.toString()}` : ''
  return request(`/api/v1/media-hub${suffix}`)
}

export function getMediaHubContent(homepageContentCode) {
  return request(`/api/v1/media-hub/contents/${homepageContentCode}`)
}

export function getMediaHubCategoryContents(categoryCode, params = {}) {
  const query = new URLSearchParams()
  if (params.page) query.set('page', params.page)
  if (params.size) query.set('size', params.size)
  if (params.sort) query.set('sort', params.sort)
  if (params.sourceType) query.set('sourceType', params.sourceType)
  if (params.mediaSourceCode) query.set('mediaSourceCode', params.mediaSourceCode)
  const suffix = query.toString() ? `?${query.toString()}` : ''
  return request(`/api/v1/media-hub/categories/${categoryCode}/contents${suffix}`)
}

export function searchMediaHubContents(params = {}) {
  const query = new URLSearchParams()
  if (params.keyword) query.set('keyword', params.keyword)
  if (params.page) query.set('page', params.page)
  if (params.size) query.set('size', params.size)
  if (params.sort) query.set('sort', params.sort)
  if (params.sourceType) query.set('sourceType', params.sourceType)
  const suffix = query.toString() ? `?${query.toString()}` : ''
  return request(`/api/v1/media-hub/search${suffix}`)
}

export function getMediaHubContentGoUrl(homepageContentCode) {
  return `${API_BASE_URL}/api/v1/media-hub/contents/${homepageContentCode}/go`
}
